<template>
  <div>
    <div class="modal">
      <Spinner v-if="isLoadingData" :fullscreen="true">
        <template v-slot:header
          >Fetch prefix list of your ASN</template
        >
        We are loading your data.
        <br />This may take a few seconds.</Spinner
      >
      <Spinner
        v-if="
          isFetchingPrefixes &&
            triggerType === triggerTypeEnum.PREFIX_SELECTED_INDIVIDUALLY
        "
        :fullscreen="true"
      >
        <template v-slot:header
          >Checking prefixes announced by your ASN</template
        >
        We are loading your data.
        <br />This may take a few seconds.</Spinner
      >
      <!-- for non-mobile -->
      <div v-if="!isMobile" class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ title }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="showConfirmModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="modal-body__left">
              <Steps
                :index="innerPageIndex"
                :isVisitedObj="isInnerPageVisitedObj"
                :isApplyBtnDisabled="isApplyBtnDisabled"
                :isSubmitBtnDisabled="isSubmitBtnDisabled"
                @changeStep="changeStep"
              ></Steps>
            </div>
            <div class="modal-body__right">
              <Trigger
                v-if="innerPageIndex === 1"
                :prefixList="prefixListOfSelectedTriggerASN"
                :prevSelectedPrefixList="selectedPrefixList"
                :prevTriggerType="triggerType"
                :prevSelectedTriggerASN="selectedTriggerASN"
                @updateSelectedPrefixList="updateSelectedPrefixList"
                @onTriggerTypeChange="setTriggerTypeChange"
                @onUpdateSelectedTriggerASN="updateSelectedTriggerASN"
              ></Trigger>
              <Rule
                v-if="innerPageIndex === 2"
                :prevAlertRule="alertRule"
              ></Rule>
              <Action
                v-if="innerPageIndex === 3"
                :actionObj="actionObj"
                :isInvalidInputWarningShown="isInvalidInputWarningShown"
              ></Action>
              <AlertName
                v-if="innerPageIndex === 4"
                :alertName="alertName"
                @confirmInput="confirmAlertName"
              ></AlertName>
            </div>
          </div>
          <div v-if="!isEditing" class="modal-footer">
            <button
              v-if="innerPageIndex > 1"
              type="button"
              class="btn btn-outline-primary"
              @click="innerPageIndex--"
            >
              Previous
            </button>
            <button
              v-if="innerPageIndex < 4"
              type="button"
              class="btn btn-primary"
              :class="{ disabled: isApplyBtnDisabled }"
              @click="applyCurrentStepSetting"
            >
              Next
            </button>
            <button
              v-if="innerPageIndex === 4"
              type="button"
              class="btn btn-primary"
              :class="{ disabled: isApplyBtnDisabled || isSubmitBtnDisabled }"
              @click="submit"
            >
              Submit
            </button>
          </div>
          <div v-else class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-primary"
              @click="showConfirmModal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :class="{ disabled: isApplyBtnDisabled || isSubmitBtnDisabled }"
              @click="submit"
            >
              Save
            </button>
          </div>
        </div>
      </div>

      <!-- for mobile -->
      <div v-if="isMobile" id="mobile" class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ title }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="closeConfirmModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div
              v-if="innerPageIndex === 0 || isEditing"
              :class="{ 'nav-page': !isEditing, 'nav-tab': isEditing }"
            >
              <Steps
                :index="innerPageIndex"
                :isVisitedObj="isInnerPageVisitedObj"
                :isApplyBtnDisabled="isApplyBtnDisabled"
                :isSubmitBtnDisabled="isSubmitBtnDisabled"
                @changeStep="changeStep"
              ></Steps>
            </div>
            <Trigger
              v-if="innerPageIndex === 1"
              :prefixList="prefixListOfSelectedTriggerASN"
              :prevSelectedPrefixList="selectedPrefixList"
              :prevTriggerType="triggerType"
              :prevSelectedTriggerASN="selectedTriggerASN"
              @updateSelectedPrefixList="updateSelectedPrefixList"
              @backToIndexPage="backToIndexPage"
              @onTriggerTypeChange="setTriggerTypeChange"
              @onUpdateSelectedTriggerASN="updateSelectedTriggerASN"
            ></Trigger>
            <Rule
              v-if="innerPageIndex === 2"
              :prevAlertRule="alertRule"
              @backToIndexPage="backToIndexPage"
            >
            </Rule>
            <Action
              v-if="innerPageIndex === 3"
              :actionObj="actionObj"
              :isInvalidInputWarningShown="isInvalidInputWarningShown"
              @backToIndexPage="backToIndexPage"
            ></Action>
            <AlertName
              v-if="innerPageIndex === 4"
              :alertName="alertName"
              @confirmInput="confirmAlertName"
              @backToIndexPage="backToIndexPage"
            ></AlertName>
          </div>
          <div v-if="!isEditing && innerPageIndex !== 0" class="modal-footer">
            <button
              v-if="innerPageIndex > 0"
              type="button"
              class="btn btn-outline-primary"
              @click="innerPageIndex--"
            >
              Previous
            </button>
            <button
              v-if="innerPageIndex < 4"
              type="button"
              class="btn btn-primary"
              :class="{ disabled: isApplyBtnDisabled }"
              @click="applyCurrentStepSetting"
            >
              Next
            </button>
            <button
              v-if="innerPageIndex === 4"
              type="button"
              class="btn btn-primary"
              :class="{ disabled: isApplyBtnDisabled || isSubmitBtnDisabled }"
              @click="submit"
            >
              Submit
            </button>
          </div>
          <div v-else-if="isEditing" class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-primary"
              @click="showConfirmModal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :class="{ disabled: isApplyBtnDisabled || isSubmitBtnDisabled }"
              @click="submit"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>

    <!--Confirm close modal -->
    <div v-if="isShowConfirmModal" class="modal confirm-close">
      <div class="modal-dialog" v-click-outside="continueEditing">
        <div class="modal-content">
          <div class="modal-header">
            Discard alert changes?
          </div>
          <div class="modal-body">The changes you made will be lost.</div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click="continueEditing"
            >
              Continue editing
            </button>
            <button
              type="button"
              class="btn btn-outline-danger"
              @click="closeAlertModal"
            >
              Discard
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
import * as vClickOutside from 'v-click-outside';
import isEqual from 'lodash.isequal';

import Steps from './Steps.vue';
import Trigger from './Trigger.vue';
import Rule from './Rule.vue';
import Action from './Action.vue';
import AlertName from './AlertName.vue';
import mixin from '../../../utils/mixin';
import Spinner from '../../ui/Spinner.vue';
import { checkIsInteger } from '../../../utils/common';
import {
  addClassModalOpenOnBody,
  removeClassModalOpenFromBody
} from '../../../utils/BOM';
import {
  TRIGGER_TYPE,
  ACTION_CHANNEL_TYPE,
  EMAIL_RECIPIENT_TYPE,
  ALERTS_REQUEST,
  RECIPIENT_TYPE_IN_API
} from '../../../constants/alertsConstant';

export default {
  name: 'CreateAlertRuleModal',
  components: { Steps, Trigger, Rule, Action, AlertName, Spinner },
  mixins: [mixin],
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    isEditing: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      innerPageIndex: 0,
      isInnerPageVisitedObj: {
        1: true,
        2: false,
        3: false,
        4: false
      },
      selectedPrefixList: [],
      alertRule: {
        isTriggeredByFirstHit: true,
        isTriggeredByHitNumber: true,
        hitNumberPerDay: 1
      },
      alertName: '',
      isShowConfirmModal: false,
      isValidAlertName: this.isEditing ? true : false,
      isPageIndexChanged: false,
      initialData: {},
      triggerType: TRIGGER_TYPE.PREFIX_DELEGATED_TO_ACCOUNT,
      actionObj: {
        isSendingAlertResolvedNotification: true,
        channelType: ACTION_CHANNEL_TYPE.EMAIL,
        recipientType: EMAIL_RECIPIENT_TYPE.MYSELF,
        recipientList: []
      },
      isInvalidInputWarningShown: false,
      triggerTypeEnum: TRIGGER_TYPE
    };
  },
  computed: {
    ...mapGetters('authStore', ['oidcUser']),
    ...mapGetters('dataStore', ['selectedASN', 'selectedAccount']),
    ...mapGetters('alertsSuspiciousTrafficStore', [
      'prefixListOfSelectedTriggerASN'
    ]),
    ...mapState('alertsSuspiciousTrafficStore', [
      'isLoadingData',
      'editingAlertObj',
      'selectedTriggerASN',
      'isFetchingPrefixes'
    ]),
    isApplyBtnDisabled() {
      const isSelectedPrefixListEmpty =
        this.triggerType === TRIGGER_TYPE.PREFIX_SELECTED_INDIVIDUALLY &&
        this.selectedPrefixList.length === 0;
      const isAlertRuleEmpty =
        !this.alertRule.isTriggeredByFirstHit &&
        !this.alertRule.isTriggeredByHitNumber;
      const isValidHitNumber =
        this.alertRule.hitNumberPerDay > 0 &&
        this.alertRule.hitNumberPerDay < 1000001 &&
        checkIsInteger(this.alertRule.hitNumberPerDay);

      const isActionListEmpty = this.actionObj.recipientList.length === 0;

      return (
        (this.innerPageIndex === 1 && isSelectedPrefixListEmpty) ||
        (this.innerPageIndex === 2 && isAlertRuleEmpty) ||
        (this.innerPageIndex === 2 && !isValidHitNumber) ||
        (this.innerPageIndex === 3 && isActionListEmpty)
      );
    },
    isSubmitBtnDisabled() {
      const isSelectedPrefixListEmpty =
        this.triggerType === TRIGGER_TYPE.PREFIX_SELECTED_INDIVIDUALLY &&
        this.selectedPrefixList.length === 0;
      const isAlertRuleEmpty =
        !this.alertRule.isTriggeredByFirstHit &&
        !this.alertRule.isTriggeredByHitNumber;
      const isValidHitNumber =
        this.alertRule.hitNumberPerDay > 0 &&
        this.alertRule.hitNumberPerDay < 1000001 &&
        checkIsInteger(this.alertRule.hitNumberPerDay);

      const isActionListEmpty = this.actionObj.recipientList.length === 0;

      return (
        isSelectedPrefixListEmpty ||
        isAlertRuleEmpty ||
        !isValidHitNumber ||
        isActionListEmpty ||
        !this.isValidAlertName
      );
    },
    title() {
      return this.isEditing ? 'Edit alert' : 'Create alert';
    }
  },
  watch: {
    selectedTriggerASN: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.fetchPrefixesByASN(newVal);
        }
      }
    }
  },
  methods: {
    ...mapActions('alertsSuspiciousTrafficStore', ['fetchPrefixesByASN']),
    ...mapMutations('alertsSuspiciousTrafficStore', ['setSelectedTriggerASN']),
    showConfirmModal() {
      const isDataChanged = this.checkIsDataChanged();

      if (isDataChanged) {
        this.isShowConfirmModal = true;
      } else {
        this.closeAlertModal();
      }
    },
    closeAlertModal() {
      this.isShowConfirmModal = false;
      this.$emit('closeModal');
    },
    continueEditing() {
      this.isShowConfirmModal = false;
    },
    submit() {
      if (this.isApplyBtnDisabled || this.isSubmitBtnDisabled) return;

      let filterPrefixes = null;

      if (this.triggerType === TRIGGER_TYPE.PREFIX_DELEGATED_TO_ACCOUNT) {
        filterPrefixes = 'allDelegatedPrefixes';
      } else if (this.triggerType === TRIGGER_TYPE.PREFIX_ANNOUNCED_BY_ASN) {
        filterPrefixes = {
          allPrefixesInOrigin: Number(this.selectedTriggerASN)
        };
      } else if (
        this.triggerType === TRIGGER_TYPE.PREFIX_SELECTED_INDIVIDUALLY
      ) {
        filterPrefixes = { individualPrefixes: [...this.selectedPrefixList] };
      }

      const actions = this.getAction();

      const alert = {
        asn: parseInt(this.selectedASN.id),
        alertName: this.alertName,
        alertRule: { ...this.alertRule },
        actions,
        filterPrefixes,
        alertOnResolve: this.actionObj.isSendingAlertResolvedNotification
      };

      this.$emit('submitAlert', alert);
    },
    changeStep(stepId) {
      !this.isPageIndexChanged && (this.isPageIndexChanged = true);

      this.innerPageIndex = stepId;
    },
    applyCurrentStepSetting() {
      if (this.isApplyBtnDisabled) {
        this.isInvalidInputWarningShown = true;
        return;
      } else {
        this.isInvalidInputWarningShown = false;
        this.innerPageIndex++;
        this.isInnerPageVisitedObj[this.innerPageIndex] = true;
      }
    },
    updateSelectedPrefixList(val) {
      this.selectedPrefixList = val;
    },
    setTriggerTypeChange(val) {
      this.triggerType = val;
    },
    backToIndexPage() {
      this.innerPageIndex = 0;
    },
    confirmAlertName({ alertName, isValidAlertName }) {
      this.alertName = alertName;
      this.isValidAlertName = isValidAlertName;
    },
    closeConfirmModal() {
      if (
        this.isMobile &&
        !this.isEditing &&
        this.innerPageIndex === 0 &&
        !this.isPageIndexChanged
      ) {
        // Close Alert modal directly when create modal on mobile devices and users have stayed on category page
        this.closeAlertModal();
      } else {
        this.showConfirmModal();
      }
    },
    checkIsDataChanged() {
      const isTriggerTypeChanged =
        this.initialData.triggerType !== this.triggerType;
      const isSelectedPrefixListChanged = !isEqual(
        this.initialData.selectedPrefixList,
        this.selectedPrefixList
      );
      const isAlertRuleChanged = !isEqual(
        this.initialData.alertRule,
        this.alertRule
      );
      const isActionListChanged = !isEqual(
        this.initialData.recipientList,
        this.actionObj.recipientList
      );
      const isAlertNameChanged = this.initialData.alertName !== this.alertName;

      return (
        isTriggerTypeChanged ||
        isSelectedPrefixListChanged ||
        isAlertRuleChanged ||
        isActionListChanged ||
        isAlertNameChanged
      );
    },
    getAction() {
      const action = this.actionObj.recipientList.map(item => {
        let channel = '';
        let recipient = {};

        switch (item.channel) {
          case ACTION_CHANNEL_TYPE.EMAIL:
            channel = ALERTS_REQUEST.channel.email;
            break;
          case ACTION_CHANNEL_TYPE.SMS:
            channel = ALERTS_REQUEST.channel.sms;
            break;
          case ACTION_CHANNEL_TYPE.SLACK:
            channel = ALERTS_REQUEST.channel.slack;
            break;
          default:
            break;
        }

        if (item.recipientType === RECIPIENT_TYPE_IN_API.APNIC_USER) {
          recipient = { apnicUser: item.recipientValue };
        } else if (
          item.recipientType === RECIPIENT_TYPE_IN_API.NON_APNIC_USER
        ) {
          recipient = { nonApnicUser: item.recipientValue };
        }

        return { channel, recipient };
      });

      return action;
    },
    updateSelectedTriggerASN(asn) {
      this.setSelectedTriggerASN(asn);
    }
  },
  mounted() {
    // Prevent background page from scrolling when the modal is open.
    addClassModalOpenOnBody();

    // Close modal with 'esc' key
    document.addEventListener('keydown', e => {
      if (e.code == 'Escape') {
        if (this.isShowConfirmModal) {
          this.continueEditing();
        } else {
          this.showConfirmModal();
        }
      }
    });

    this.innerPageIndex = this.isMobile && !this.isEditing ? 0 : 1;

    this.setSelectedTriggerASN(this.selectedASN.id);

    // If in edit mode, preset Alert config
    if (this.isEditing) {
      if (this.editingAlertObj.filterPrefixes === 'allDelegatedPrefixes') {
        this.triggerType = TRIGGER_TYPE.PREFIX_DELEGATED_TO_ACCOUNT;
      } else if (this.editingAlertObj.filterPrefixes?.allPrefixesInOrigin) {
        this.triggerType = TRIGGER_TYPE.PREFIX_ANNOUNCED_BY_ASN;
        this.setSelectedTriggerASN(
          this.editingAlertObj.filterPrefixes.allPrefixesInOrigin
        );
      } else if (this.editingAlertObj.filterPrefixes?.individualPrefixes) {
        this.triggerType = TRIGGER_TYPE.PREFIX_SELECTED_INDIVIDUALLY;
        this.selectedPrefixList = JSON.parse(
          JSON.stringify(this.editingAlertObj.filterPrefixes.individualPrefixes)
        );
      }

      this.alertRule.isTriggeredByFirstHit =
        this.editingAlertObj.triggerOnFirstHit || false;
      this.alertRule.isTriggeredByHitNumber =
        !!this.editingAlertObj.triggerOnNumHits || false;
      this.alertRule.hitNumberPerDay =
        this.editingAlertObj.triggerOnNumHits || 1;

      this.alertName = this.editingAlertObj.name;

      // Init action step when edit alert
      if (this.editingAlertObj.actions) {
        this.actionObj.isSendingAlertResolvedNotification = this.editingAlertObj.alertOnResolve;

        this.actionObj.recipientList = this.editingAlertObj.actions.map(
          item => {
            if (item.channel === ALERTS_REQUEST.channel.email) {
              if (item.recipient.apnicUser) {
                return {
                  channel: ACTION_CHANNEL_TYPE.EMAIL,
                  recipientType: RECIPIENT_TYPE_IN_API.APNIC_USER,
                  recipientValue: item.recipient.apnicUser
                };
              } else if (item.recipient.nonApnicUser) {
                return {
                  channel: ACTION_CHANNEL_TYPE.EMAIL,
                  recipientType: RECIPIENT_TYPE_IN_API.NON_APNIC_USER,
                  recipientValue: item.recipient.nonApnicUser
                };
              }
            } else if (item.channel === ALERTS_REQUEST.channel.sms) {
              return {
                channel: ACTION_CHANNEL_TYPE.SMS,
                recipientType: RECIPIENT_TYPE_IN_API.NON_APNIC_USER,
                recipientValue: item.recipient.nonApnicUser
              };
            } else if (item.channel === ALERTS_REQUEST.channel.slack) {
              return {
                channel: ACTION_CHANNEL_TYPE.SLACK,
                recipientType: RECIPIENT_TYPE_IN_API.NON_APNIC_USER,
                recipientValue: item.recipient.nonApnicUser
              };
            }
          }
        );
      }
    }

    this.initialData = {
      triggerType: this.triggerType,
      selectedPrefixList: [...this.selectedPrefixList],
      alertRule: { ...this.alertRule },
      recipientList: JSON.parse(JSON.stringify(this.actionObj.recipientList)),
      alertName: this.alertName
    };
  },
  beforeDestroy() {
    // Allow background page to scroll when the modal is closed.
    removeClassModalOpenFromBody();
  }
};
</script>

<style lang="scss" scoped>
.modal {
  z-index: 1030;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba($color: #000000, $alpha: 0.6);
}

.modal-dialog {
  max-width: initial;
  width: 80%;
}

.modal-header {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;

  h5 {
    height: 2.375rem;
    line-height: 2.375rem;
  }

  .close {
    font-size: 2rem;
  }

  &__left {
    flex: 1;
  }

  &__right {
    flex: 2;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;

    & > span {
      font-weight: 600;
    }
  }
}

.modal-body {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  padding: 0;
  height: 70vh;

  &.disabled-mask::before {
    @include disabled-mask;
  }

  &__left {
    width: 30%;
  }

  &__right {
    width: 70%;
  }
}

.modal-footer {
  position: relative;

  &.disabled-mask::before {
    @include disabled-mask;
  }

  .disabled {
    cursor: not-allowed;
  }
}

#mobile {
  &.modal-dialog {
    width: 100vw;
    height: 100%;
    margin: 0;
  }

  .modal-content {
    height: 100%;
  }

  .modal-header {
    height: 3rem;
    line-height: 3rem;
    background-color: $text-light-blue;

    h5 {
      line-height: 1;
      color: #fff;
    }

    button {
      margin: -1.5rem -0.5rem 0 0;
      padding: 1rem;
      color: #fff;
      opacity: 1;
      font-size: 2rem;
    }
  }

  .modal-body {
    flex-direction: column;

    &.disabled-mask::before {
      @include disabled-mask;
      top: 5rem;
    }

    .nav-page {
      height: 100%;
      padding-top: 1.5rem;
      background-color: $background-grey;

      & > span {
        padding: 0 1rem;
        font-weight: 600;
      }
    }
  }

  .modal-footer {
    justify-content: space-evenly;
  }
}

.confirm-close.modal {
  z-index: 1031;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba($color: #000000, $alpha: 0.6);

  .modal-dialog {
    max-width: initial;
    width: 40%;
    min-width: 22rem;
    max-width: 28rem;
  }

  .modal-header {
    font-weight: 600;
    padding-top: 1rem;
  }

  .modal-body {
    height: 4rem;
    padding: 1rem;
  }

  .modal-footer {
    justify-content: space-evenly;
  }
}
</style>
